module.exports = __webpack_public_path__ + "img/画板 1 拷贝 13.0090fa82.jpg";